import React from 'react'
import ReactDOM from 'react-dom'
import PatternTriangles from './PatternTriangles'
import PatternLines from './PatternLines'
import { useState, useEffect } from 'react'
import useWindowDimensions from './useWindowDimensions'
import './styles.css'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import { makeStyles } from '@material-ui/core/styles'
import { SketchPicker } from 'react-color'

import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import {
	IconAdd,
	IconRemove,
	IconDownload,
	IconForwards,
	IconPalette,
	IconPipette,
	IconPatternTriangles,
	IconPatternShapes,
} from './Icons/'

const colorModes = {
	colorful: {
		main: ['#FFFFFF', '#C800FF', '#0015D6', '#FF005D', '#43C9CB', '#ffcc00'],
		bg: ['#141414', '#000000', '#FFFFFF', '#EDA1F8'],
	},
	bw: {
		main: ['#FFFFFF', '#999999', '#CCCCCC', '#333333', '#1A1A1A', '#666666'],
		bg: ['#141414', '#DDDDDD', '#000000', '#FFFFFF'],
	},
	monotone: {
		main: ['#B30089', '#7400B1', '#FF44B2', '#AB00BE', '#D612FF', '#FF005D'],
		bg: ['#760083', '#141414', '#310083', '#FFFFFF', '#F495FF'],
	},
	minimal: {
		main: ['#141414', '#141414', '#141414', '#333333', '#000000', '#222222'],
		bg: ['#141414', '#FFFFFF', '#1F1F1F', '#0087FF', '#00FFC5', '#FF3A00'],
	},
	transparencyBlack: {
		main: [
			'#00000011',
			'#00000033',
			'#000000FF',
			'#00000066',
			'#000000DD',
			'#00000033',
		],
		bg: ['#FF3A00', '#0087FF', '#00FFC5', '#222222', '#F5F5F5'],
	},
	transparencyWhite: {
		main: [
			'#FFFFFF11',
			'#FFFFFF33',
			'#FFFFFFFF',
			'#FFFFFF66',
			'#FFFFFFDD',
			'#FFFFFF33',
		],
		bg: ['#FF3A00', '#0087FF', '#00FFC5', '#F0F0F0', '#141414'],
	},
}

const theme = createMuiTheme({
	palette: {
		type: 'dark',
		primary: {
			light: '#222',
			main: '#222',
			dark: '#222',
			contrastText: '#fefefe',
		},
		secondary: {
			light: '#777',
			main: '#777',
			dark: '#777',
			contrastText: '#fff',
		},
	},
})

const useStyles = makeStyles((theme) => ({
	margin: {
		margin: theme.spacing(1),
	},
	extendedIcon: {
		marginRight: theme.spacing(1),
	},
}))

function randomBoolean() {
	return Math.random() >= 0.5
}

function randomInt(min, max) {
	return Math.floor(Math.random() * max) + min
}

function randomPattern(min, max) {
	let newArray = []
	for (let i = 0; i < randomInt(min, max); i++) {
		newArray.push(randomBoolean())
	}
	return newArray
}

// function convertRange(value, r1, r2) {
// 	return ((value - r1[0]) * (r2[1] - r2[0])) / (r1[1] - r1[0]) + r2[0]
// }

function App() {
	const classes = useStyles()
	const { height, width } = useWindowDimensions()
	const [maxComplexity, setMaxComplexity] = useState(5)
	const [minComplexity, setMinComplexity] = useState(2)
	const [rotation, setRotation] = useState(0)
	const [patternX, setPatternX] = useState(
		randomPattern(minComplexity, maxComplexity)
	)
	const [patternY, setPatternY] = useState(
		randomPattern(minComplexity, maxComplexity)
	)
	const initialMode = Object.keys(colorModes)[
		Math.floor(Math.random() * Object.keys(colorModes).length)
	]
	const [shapeSize] = useState(80)
	const [colors, setColors] = useState(colorModes[initialMode].main)
	const [colorMode, setColorMode] = useState(initialMode)
	const [colorPickerVisible, setColorPickerVisible] = useState(false)
	const [bg, setBg] = useState(colorModes[initialMode].bg[0])
	const [bgOptions, setBgOptions] = useState(colorModes[initialMode].bg)
	const [isExport, setExport] = useState(false)
	const [downloadCount, setDownloadCount] = useState(0)
	const [sketch, setSketch] = useState(Math.floor(Math.random() * 2))

	const decreaseComplexity = () => {
		if (minComplexity > 1) {
			setMaxComplexity(maxComplexity / 1.25)
			setMinComplexity(minComplexity - 1)
		} else if (maxComplexity > 3) setMaxComplexity(maxComplexity - 1)
	}

	const increaseComplexity = () => {
		setMaxComplexity(maxComplexity * 1.25)
		setMinComplexity(minComplexity + 1)
	}

	const increaseRotation = () => {
		setRotation(rotation + 45 / 4)
	}

	const toggleColorMode = () => {
		const currentIndex = Object.keys(colorModes).indexOf(colorMode)
		if (currentIndex + 1 < Object.keys(colorModes).length) {
			setColors(colorModes[Object.keys(colorModes)[currentIndex + 1]].main)
			setBg(colorModes[Object.keys(colorModes)[currentIndex + 1]].bg[0])
			setBgOptions(colorModes[Object.keys(colorModes)[currentIndex + 1]].bg)
			setColorMode(Object.keys(colorModes)[currentIndex + 1])
		} else {
			setColors(colorModes[Object.keys(colorModes)[0]].main)
			setBg(colorModes[Object.keys(colorModes)[0]].bg[0])
			setBgOptions(colorModes[Object.keys(colorModes)[0]].bg)
			setColorMode(Object.keys(colorModes)[0])
		}
	}

	const toggleExport = () => {
		setExport(!isExport)
		setDownloadCount(downloadCount + 1)
		// addCount ==> Data to Airtable
	}

	useEffect(() => {
		setPatternX(randomPattern(minComplexity, maxComplexity))
		setPatternY(randomPattern(minComplexity, maxComplexity))
	}, [maxComplexity, minComplexity])

	useEffect(() => {
		// retrieveCount ==> Data from Airtable
	}, [])

	return (
		<ThemeProvider theme={theme}>
			<div>
				{sketch === 0 ? (
					<PatternTriangles
						width={width}
						height={height}
						rotation={rotation}
						patternX={patternX}
						patternY={patternY}
						shapeSize={shapeSize}
						colors={colors}
						backgroundColor={bg}
						export={() => {
							if (isExport) {
								setExport(false)
								return true
							} else return false
						}}
					/>
				) : (
					<PatternLines
						width={width}
						height={height}
						rotation={rotation}
						patternX={patternX}
						patternY={patternY}
						shapeSize={shapeSize / 2}
						colors={colors}
						backgroundColor={bg}
						export={() => {
							if (isExport) {
								setExport(false)
								return true
							} else return false
						}}
					/>
				)}
			</div>
			<div
				style={{
					position: 'absolute',
					bottom: 10,
					width: '100%',
					display: 'flex',
					justifyContent: 'center',
				}}
			>
				<AppBar
					position="fixed"
					color="primary"
					style={{
						top: 'auto',
						bottom: 0,
						left: 'auto',
						right: 'auto',
						maxWidth: 440,
					}}
				>
					<Toolbar>
						<ToggleButtonGroup
							edge="start"
							value={sketch}
							exclusive
							onChange={(event, newValue) => {
								if (newValue !== null) setSketch(newValue)
							}}
							aria-label="text alignment"
						>
							<ToggleButton
								aria-label="Triangles"
								value={0}
								color="inherit"
								size="small"
							>
								<IconPatternTriangles />
							</ToggleButton>
							<ToggleButton
								aria-label="Contours"
								value={1}
								color="inherit"
								size="small"
							>
								<IconPatternShapes />
							</ToggleButton>
						</ToggleButtonGroup>
						{/* <IconButton
							edge="start"
							size="small"
							aria-label="visual"
							onClick={() => {
								setSketch(sketch === 0 ? 1 : 0)
							}}
							className={classes.margin}
							color="inherit"
							disableRipple
						>
							<SkipNextIcon />
						</IconButton> */}
						<div style={{ flexGrow: 1 }} />
						<IconButton
							size="small"
							aria-label="mode"
							onClick={toggleColorMode}
							className={classes.margin}
							color="inherit"
							disableRipple
						>
							<IconPalette />
						</IconButton>
						{colorPickerVisible && (
							<div style={{ position: 'absolute', bottom: '4em' }}>
								<SketchPicker
									disableAlpha
									color={bg}
									presetColors={bgOptions}
									onChange={(color) => {
										setBg(color.hex)
									}}
								/>
							</div>
						)}
						<IconButton
							size="small"
							aria-label="picker"
							onClick={() => {
								setColorPickerVisible(!colorPickerVisible)
							}}
							className={classes.margin}
							color={colorPickerVisible ? 'secondary' : 'inherit'}
							disableRipple
						>
							<IconPipette />
						</IconButton>
						<div style={{ flexGrow: 1 }} />
						<IconButton
							size="small"
							aria-label="decrease"
							onClick={decreaseComplexity}
							className={classes.margin}
							color="inherit"
							disableRipple
						>
							<IconRemove />
						</IconButton>
						<IconButton
							size="small"
							aria-label="add"
							onClick={increaseComplexity}
							className={classes.margin}
							color="inherit"
							disableRipple
						>
							<IconAdd />
						</IconButton>
						<IconButton
							size="small"
							aria-label="add"
							onClick={increaseRotation}
							className={classes.margin}
							color="inherit"
							disableRipple
						>
							<IconForwards />
						</IconButton>
						<div style={{ flexGrow: 1 }} />
						<IconButton
							edge="end"
							size="small"
							aria-label="export"
							onClick={toggleExport}
							className={classes.margin}
							color="inherit"
							disableRipple
						>
							<Badge color="secondary" badgeContent={downloadCount}>
								<IconDownload />
							</Badge>
						</IconButton>
					</Toolbar>
				</AppBar>
			</div>
		</ThemeProvider>
	)
}

const rootElement = document.getElementById('root')
ReactDOM.render(<App />, rootElement)
